import React, { cloneElement } from 'react';
import { cn } from '../../utils/cn';
import { mergeProps } from '@react-aria/utils';
export var BorderState;
(function (BorderState) {
    BorderState[BorderState["None"] = 0] = "None";
    BorderState[BorderState["Selected"] = 1] = "Selected";
    BorderState[BorderState["Unselected"] = 2] = "Unselected";
})(BorderState || (BorderState = {}));
export const buttonBorderForState = (state) => cn('border border-transparent', {
    'border-l-bruise border-t-bruise border-r-bruise': state === BorderState.Selected,
    'border-b-bruise': state === BorderState.Unselected,
});
const popunderStyle = cn('absolute top-full left-0 right-0 max-h-popunder', 'bg-gesso', 'border-l border-r border-b border-bruise', 'overflow-y-scroll touch-action-pan-y overscroll-contain');
export function Explorer({ className, start, middle, end, top, topPopunder, bottom, bottomPopunder, children, }) {
    var _a, _b;
    return (React.createElement("div", { className: cn(className, 'bg-gesso', 'flex flex-col min-w-0 min-h-0') },
        cloneElement((top !== null && top !== void 0 ? top : React.createElement("div", null)), mergeProps((_a = top) === null || _a === void 0 ? void 0 : _a.props, {
            className: cn('relative', 'flex flex-row items-stretch min-w-0 min-h-0'),
        }), [
            cloneElement(start, mergeProps(start.props, { key: 'start', className: cn('flex-none p-3') })),
            cloneElement(middle, mergeProps(middle.props, { key: 'middle', className: cn('flex-1', 'p-2') })),
            cloneElement(end, mergeProps(end.props, { key: 'end', className: cn('flex-none p-3') })),
            topPopunder &&
                cloneElement(topPopunder, mergeProps(topPopunder.props, {
                    key: 'popunder',
                    className: cn(popunderStyle, 'z-20'),
                })),
        ]),
        children &&
            cloneElement((bottom !== null && bottom !== void 0 ? bottom : React.createElement("div", null)), mergeProps((_b = bottom) === null || _b === void 0 ? void 0 : _b.props, {
                className: cn('relative', 'flex flex-row items-stretch min-w-0 min-h-0', 'border-t border-smudge'),
            }), [
                children &&
                    React.Children.map(children, (child, i) => child &&
                        cloneElement(child, mergeProps(child.props, {
                            className: cn('flex-1', i > 0 && 'border-l border-l-smudge'),
                        }))),
                bottomPopunder &&
                    cloneElement(bottomPopunder, mergeProps(bottomPopunder.props, {
                        key: 'popunder',
                        className: cn(popunderStyle, 'z-10'),
                    })),
            ])));
}
